import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BotCardType, DialogMessage, HistoryItemResponse } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { EventManagerAdminService } from 'src/app/shared/services/event-manager/event-manager-admin.service';
import { BUTTONCARDBUTTON } from '../components/ai-bot/utils/bot-chat-dialog/message-card/button-card/button-card.component';
import { HelperManagerAdminService } from './helper-manager-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { StageManagerService } from './stage-manager.service';

@Injectable({
  providedIn: 'root'
})
export class CardsManagerService {
  constructor(
    private _http: HttpClient,
    private stageManager: StageManagerService,
    private botIdService: BotidService,
    private helperManager: HelperManagerAdminService, // Assuming this is the correct service for getting image URLs
    private eventManager: EventManagerAdminService
  ) { }

  public async buttons(buttons: BUTTONCARDBUTTON[], cssClass: string = '') {
    buttons = buttons.map((b) => {
      if (typeof b === 'string') {
        return b;
      }
      return { ...b, onClick: "" + b.onClick };
    });
    await this.addBotCard({ type: BotCardType.buttonsCard, data: { buttons, cssClass } });
  }

  public async iframe(url: string, cssClass: string = '') {
    await this.addBotCard({ type: BotCardType.iframeCard, data: { url, cssClass } });
  }

  public async html(html: string, cssClass: string = '', id = '') {
    await this.addBotCard({ type: BotCardType.htmlCard, data: { html, cssClass, id } });
  }

  public async debugEvent(html: string, cssClass: string = '', id = '') {
    await this.addBotCard({ type: BotCardType.htmlCard, data: { html, cssClass, id } }, false);
  }

  public loading(text: string = '', icon: string = '', cssClass: string = '') {
    const payload = { type: BotCardType.loadingCard, data: { text, cssClass, icon } };
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.CARDS.loading", payload);
  }

  public removeLoading() {
    this.eventManager._trigger_RAGAI_EVENT("RAGAI.CARDS.removeLoading");
  }

  public async youtube(id: string, cssClass: string = '') {
    await this.addBotCard({ type: BotCardType.youtubeCard, data: { id, cssClass } });
  }

  public async vimeo(id: string, hash: string, cssClass: string = '') {
    await this.addBotCard({ type: BotCardType.vimeoCard, data: { id, hash, cssClass } });
  }

  public async image(src: string, altText: string = '', cssClass: string = '') {
    if (!src.startsWith('http') && !src.startsWith('data')) {
      src = this.helperManager.getImageURlFromSkill(src);
    }
    await this.addBotCard({ type: BotCardType.imageCard, data: { src, altText, cssClass } });
  }

  public async stageListButtons() {
    //const data: { text: string, onClick: () => void, className?: string }[] = [];
    const data: BUTTONCARDBUTTON[] = [];
    for (const stage of this.stageManager.visibleStages) {
      data.push({
        text: stage.title,
        onClick: "function (){ RAGAI.STAGE.goTo('" + stage.name + "') ; }",
        className: "stage-button"
      });
    }
    await this.buttons(data);
  }

  public async addBotCard(payload: { type: string, data: unknown }, triggerEvent: boolean = true) {
    if (triggerEvent) {
      this.eventManager._trigger_RAGAI_EVENT("RAGAI.CARDS.ADD", payload);
      this.eventManager._trigger_RAGAI_EVENT("RAGAI.CARDS.ADD." + payload.type, payload);
    }
    const backendPayload: DialogMessage = { content: [{ type: "text", text: JSON.stringify(payload) }], role: 'botcard', bypass: false };
    const res = await firstValueFrom(this._http.post<HistoryItemResponse[]>('/api/toolbox/membot/user/createmessagesinthread/' + this.botIdService.getBotId(), { messages: [backendPayload] }));
    if (res[0] != null) {
      return res[0];
    }
    throw new Error("Failed to add bot card");
  }
}
